import React from "react";

interface IconProps {
  color?: string;
  width?: number | string;
  height?: number | string;
  onClick?: () => void;
}

const ArrowLeftIcon: React.FC<IconProps> = ({
  color = "#000000",
  width = 25,
  height = 25,
  onClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      onClick={onClick}
    >
      <path d="M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z" />
    </svg>
  );
};

export default ArrowLeftIcon;